import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MonthlyThroughputsChart from "../components/MonthlyThroughputsChart";
import MonthlyPlanningsTable from "../components/MonthlyPlanningsTable";
import DateSelector from "../components/DateSelector";
import MonthlyViewLayout from "../components/MonthlyViewLayout";
import { toMonthStart } from "../utils/month";
import { formatLocalDate } from "../utils/localDateTime";

const MonthlyPlanningsOverview = () => {
  const { date } = useParams();
  const navigate = useNavigate();
  const rawDate = date || formatLocalDate(new Date());
  const selectedDate = toMonthStart(rawDate);
  const [chartLoading, setChartLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    if (!date || date !== selectedDate) navigate(`/chart/monthly/plannings/${selectedDate}`, { replace: true });
  }, [date, selectedDate, navigate]);

  // Reset loading states when date changes
  useEffect(() => {
    setChartLoading(true);
    setTableLoading(true);
  }, [selectedDate]);

  const handleBlockClick = useCallback((clickedDate) => {
    // Format date as YYYY-MM-DD if needed
    const targetDate = clickedDate instanceof Date
      ? formatLocalDate(clickedDate)
      : clickedDate
    navigate(`/chart/daily/plannings/${targetDate}`)
  }, [navigate]);

  const handleChartLoadingChange = useCallback((loading) => {
    setChartLoading(loading);
  }, []);

  const handleTableLoadingChange = useCallback((loading) => {
    setTableLoading(loading);
  }, []);

  const isAnyLoading = chartLoading || tableLoading;

  return (
    <MonthlyViewLayout date={selectedDate}>
      <DateSelector
        date={selectedDate}
        setDate={(newDate) => navigate(`/chart/monthly/plannings/${newDate}`)}
        disabled={isAnyLoading}
        mode="month"
      />
      <MonthlyThroughputsChart
        date={selectedDate}
        onClick={handleBlockClick}
        onLoadingChange={handleChartLoadingChange}
      />
      <MonthlyPlanningsTable
        date={selectedDate}
        onSelectWorkcell={(id) => navigate(`/chart/workcell/${id}/monthly/${selectedDate}`)}
        onLoadingChange={handleTableLoadingChange}
      />
    </MonthlyViewLayout>
  );
};

export default MonthlyPlanningsOverview;

// onSelectWorkcell={(id) => navigate(`/chart/monthly/plannings/${selectedDate}/${id}`)}
